<template>
    <div>
        <div class="header-top">
            <div class="top-content">
                <div class="top-right">
                    <router-link v-if="!logined" to="/login" class="ns-text-color" style=" color: #fff !important;

  font-weight: 600;
  ">สวัสดี，กรุณาเข้าสู่ระบบ</router-link>
                    <div v-if="logined" class="member-info">
                        <router-link to="/member/index">{{ member.nickname || member.username }}</router-link>
                        <span @click="logout" style="color: #fff;">ออกจากระบบ</span>
                    </div>
                    <router-link v-if="!logined" to="/register">สมัครสมาชิก</router-link>
                    <router-link to="/member/order_list">คำสั่งซื้อของฉัน</router-link>
					<router-link to="/member/footprint">ประวัติการรับชม</router-link>
					<router-link to="/member/collection">ที่ฉันชื่นชอบ</router-link>
					
                    <router-link to="/cms/help">ศูนย์ช่วยเหลือ</router-link>
					<router-link to="/cms/notice">ประกาศ</router-link>
                    <el-dropdown v-if="qrcode">
                        <span class="el-dropdown-link" style=" color: #fff;
  font-weight: 600;
  ">
                            เวอร์ชั่นมือถือ
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <div class="mobile-qrcode"><img :src="$img(qrcode)" /></div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import { getToken } from "@/utils/auth"

    export default {
        props: {},
        data() {
            return {}
        },
        created() {
            this.$store.dispatch("site/qrCodes")
            this.$store.dispatch("member/member_detail")
            this.$store.dispatch("site/defaultFiles")
            this.$store.dispatch("site/addons")
        },
        mounted() {},
        watch: {},
        methods: {
            logout() {
                this.$store.dispatch("member/logout")
            }
        },
        components: {},
        computed: {
            ...mapGetters(["wapQrcode", "member", "addonIsExit"]),
            qrcode: function() {
                return this.wapQrcode === "" ? "" : this.wapQrcode.path.h5.img
            },
            logined: function() {
                return this.member !== undefined && this.member !== "" && this.member !== {}
            }
        }
    }
</script>

<style scoped lang="scss">
    .header-top {
        width: 100%;
        height: 31px;
        font-size: 12px;
        background-color: rgb(51, 51, 51);

        .el-dropdown {
            font-size: $ns-font-size-sm;
        }
        .top-content {
            width: $width;
            height: 100%;
            margin: 0 auto;
            .top-right {
                height: 100%;
                float: right;
                font-size: $ns-font-size-sm;
                color: $ns-text-color-black;
                a {
                    float: left;
					    color: #ffffff;
                    line-height: 31px;
                    padding: 0 10px;
                    &:hover {
                        color: $base-color;
                    }
                }
                div {
                    float: left;
                    height: 100%;
                    margin-left: 10px;
                    cursor: pointer;
                    line-height: 31px;
                    padding: 0 5px;

                    &.member-info {
                        margin-left: 0;
                        span:first-child {
                            margin-right: 10px;
                        }
                    }
                    span:hover {
                        color: $base-color;
                    }
                    &.el-dropdown:hover {
                        background-color: rgb(42,42,42);
                    }
                }
            }
        }
    }
    .mobile-qrcode {
        padding: 10px 0;
    }
	.router-link-active{
		color:$base-color;
	}.header-top .top-content {
    width: 1521px;
    height: 100%;
    margin: 0 auto;
}.header-top {
    width: 100%;
    height: 31px;
    font-size: 12px;
    background-color: rgb(51 51 51);
}
</style>
